import userProfileDetailsEdit from "./userProfileDetailsEdit";

export default userProfileDetailsEdit;
